import { makeStyles } from '@mui/styles';

export const useLockerUtilisationStyles = makeStyles(() => ({
  card: {
    width: '100%',
    padding: '16px',
    borderRadius: '10px',
    minHeight: '100%',
    height: 'max-content'
  },
  noDataMessage: {
    height: '100px',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    fontSize: '16px'
  }
}));
